import axios from "axios";
const baseURL = process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5001/api';

const authHeader = (config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
};

const useApi = axios.create({
    baseURL: baseURL,
    headers: {
        "Content-Type": "application/json;charset=UTF-8",
    },
});

const useAuthApi = axios.create({
    baseURL: baseURL,
    headers: {
        ...authHeader.headers,
        "Content-Type": "application/json;charset=UTF-8"
    }
})

const useApi_file = axios.create({
    baseURL: baseURL,
    headers: {
        "Content-Type": "multipart/form-data",
    },
});
useApi.interceptors.response.use((response) => response);

useAuthApi.interceptors.request.use(authHeader, (error) => {
    return Promise.reject(error);
});

useApi_file.interceptors.response.use((response) => response);

export { useApi as default, useApi, useAuthApi, useApi_file };
